import React, {useEffect, useState} from 'react';
import {DropDownFlex, Modal, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import {LocalizationProvider, StaticTimePicker} from "@mui/x-date-pickers";
import AcpSettingsService from "../services/AcpSettingsService";
import styles from './Reset24hFileModal.module.scss';
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {Moment} from "moment";

function Reset24hFileModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, updateACPSettings: Function }) {

    const [selectedSettingId, setSelectedSettingId] = useState(0);
    const [timeValue, setTimeValue] = useState<Moment>();
    const [acpSettings, setAcpSettings] = useState<{ acpSettingsId: number, description: string }[]>();
    const [loading, setLoading] = useState<boolean>();

    useEffect(() => {
        setLoading(true)
        initAcpSettings();
    }, []);

    const submitButtonDisabled = () => {
        return !selectedSettingId || !timeValue;
    }

    const initAcpSettings = () => {
        AcpSettingsService.getAcpSettingsForCustomer(props.selectedCustomer.clientId)
            .then(n => {
                setAcpSettings(n);
                setLoading(false);
            });
    }

    const renderAcpSettingsDropDown = () => {
        const updatedAcpSettings = acpSettings?.map(setting => {
            return {
                label: setting.description,
                value: setting.acpSettingsId
            }
        });

        updatedAcpSettings?.unshift(
            {label: 'Select an ACP Settings', value: 0}
        );

        if (updatedAcpSettings && updatedAcpSettings.length > 1) {
            return <DropDownFlex
                className={styles.AcpSettingsDropdown}
                data={updatedAcpSettings}
                value={selectedSettingId}
                onChange={e => {
                    setSelectedSettingId(e.value)
                }}
            />
        } else {
            return <h3>No Settings Found</h3>
        }
    }

    const renderTimePicker = () => {
        return (
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <StaticTimePicker
                    orientation="portrait"
                    ampm={false}
                    ampmInClock={true}
                    onChange={(timedate: any) => {
                        setTimeValue(timedate)
                    }}
                    slotProps={{
                        actionBar: {
                            actions: [] // Disables 'ok' and 'cancel' buttons of TimePicker
                        },
                        toolbar: {
                            className: styles.TimePickerHeader
                        },
                        leftArrowIcon: {
                            style: {display: 'none'} // Hides left arrow
                        },
                        rightArrowIcon: {
                            style: {display: 'none'} // Hides left arrow
                        }
                    }}
                />
            </LocalizationProvider>
        );
    }

    const renderModalContent = () => {
        let modalContent;
        if (loading) {
            modalContent = <Spinner/>;
        } else {
            modalContent = (
                <>
                    {renderAcpSettingsDropDown()}
                    {selectedSettingId ? renderTimePicker() : undefined}
                </>
            )
        }

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='teal'
            heading={'Reset ACP 24h File Time'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            onPrimaryButtonClick={() =>
                props.updateACPSettings(props.selectedCustomer.clientId, selectedSettingId, timeValue)
            }
            primaryButtonProps={{disabled: submitButtonDisabled()}}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default Reset24hFileModal;
